import GameManager from '../../core/GameManager';
import { ScenarioEndType, ScenarioSceneType } from '../../misc/BleedingControlScenario';
import MainTutorialScenario from './MainTutorialScenario/MainTutorialScenario';

export default class TutorialScenario extends MainTutorialScenario {
	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName, ScenarioSceneType.Tutorial, ScenarioEndType.end);
	}

	public soundFolderAndPath(section: string, part: string): string {
		return '0' + section + '-Mechanics Intro ' + section + '/BC-Mech-' + section + '-Intro-Part-' + part;
	}
}